import {useParams} from "react-router-dom";
import Calibration from "./Calibration.tsx";


export function CalibrationPage() {
    const {calibrationId} = useParams();
    return <Calibration calibrationId={calibrationId}/>;
}